module.exports = __webpack_public_path__ + "img/Girl.4228b209.png";